import { GetParentMaterialityAssessmentQuery_ } from 'models';
import { Requirement } from '../MaterialityAssessment.d';

export enum StandardMaterialityState {
  mandatory = 'mandatory',
  toAssess = 'toAssess',
  material = 'material',
  notMaterial = 'notMaterial',
  gatherData = 'gatherData',
  collectDataMandatory = 'collectDataMandatory',
  collectData = 'collectData',
  doNotCollect = 'doNotCollect',
  phasedIn = 'phasedIn',
}

export enum MetricMaterialityState {
  toAssess = 'toAssess',
  material = 'material',
  notMaterial = 'notMaterial',
  gatherData = 'gatherData',
  collectData = 'collectData',
  collectDataMandatory = 'collectDataMandatory',
  doNotCollect = 'doNotCollect',
  phasedIn = 'phasedIn',
  doNotInclude = 'doNotInclude',
}

export enum MaterialityState {
  materialMandatory = 'materialMandatory',
  mandatory = 'mandatory',
  toAssess = 'toAssess',
  material = 'material',
  notMaterial = 'notMaterial',
  gatherData = 'gatherData',
  collectDataMandatory = 'collectDataMandatory',
  collectData = 'collectData',
  doNotCollect = 'doNotCollect',
  phasedIn = 'phasedIn',
  doNotInclude = 'doNotInclude',
}

export enum ParentMaterialityState {
  materialMandatory = 'materialMandatory',
  mandatory = 'mandatory',
  toAssess = 'toAssess',
  material = 'material',
  notMaterial = 'notMaterial',
  gatherData = 'gatherData',
  phasedIn = 'phasedIn',
}

export type Materiality =
  | 'material'
  | 'notMaterial'
  | 'materialMandatory'
  | 'mandatory'
  | 'toAssess'
  | 'gatherData'
  | 'collectDataMandatory'
  | 'collectData'
  | 'doNotCollect';

export enum MaterialityStatus {
  material = 'Material',
  notMaterial = 'Not material',
  toAssess = 'To assess',
  gatherData = 'Not material but collect data',
  collectData = 'Collect data',
  doNotCollect = 'Do not collect',
  phasedIn = 'Material but phased-in',
}

export enum VSMEMaterialityStatus {
  material = 'Collect and report',
  notMaterial = 'Not collected',
  gatherData = 'Only collect',
}

export type ParentMaterialMetrics = {
  metricRef: string;
  isMaterial?: boolean | null;
  isDataGatheringOnly?: boolean;
  isPhasedIn?: boolean;
  dataCollection?: string | null | undefined;
  metric: {
    disclosureRequirementRef: string;
    childrenMetricsCount?: number | null | undefined;
  };
}[];

export type StandardMaterialityFields = {
  material: StandardMaterialityState | null;
};

export type MaterialityFields = {
  material: MaterialityState | null;
};

export type AdditionalType = Requirement['additionalTypes'][number]['additionalType'];

export type ParentStandardMaterialityData = NonNullable<
  NonNullable<GetParentMaterialityAssessmentQuery_['EsrsAssessment_by_pk']>['parentAssessment']
>['materialStandards'][number];

export type ParentMaterialMetricsType = ParentStandardMaterialityData['materialMetrics'];

export type MappedDisclosureRequirements = {
  title: string;
  drRef: string;
  materialityStatus: MaterialityState;
  order: number;
  parentMateriality: Materiality | MaterialityState;
  metrics: (Requirement['metrics'][number] & {
    tags: {
      type: string;
    }[];
  })[];
  description: string | null | undefined;
  additionalTypes: AdditionalType[];
  isMandatory: boolean;
}[];
